module.exports = __webpack_public_path__ + "img/pr-4.713a5f5d.png";